import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TruckOwnerService } from "../truck-owner.service";

@Component({
  selector: "app-delete-dialog",
  templateUrl: "./delete-dialog.component.html",
  styleUrls: ["./delete-dialog.component.css"],
})
export class DeleteDialogComponent implements OnInit {
  title: string = "";
  token: any;

  constructor(
    private matdialogref: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: TruckOwnerService,
    private snackBar: MatSnackBar
  ) {
    this.title = data.data === 'reject' ? 'Reject'
                : data.data === 'rate-delete' ? 'Delete Bid Rate'
                : 'Delete';
    this.title = data.data === 'reject' ? 'Reject' 
      : data.data === 'rate-delete' ? 'Delete Bid Rate' 
        : data.data === 'reject-bid' ? 'Reject Bid'
          : 'Delete';
  }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
  }

  reject() {
    if (this.data.data === 'rate-delete') {
      this.services.deleteBidRate(this.data.item._id, this.token).subscribe(
        () => {
          this.matdialogref.close({ event: 'Success' });
        },
        (error) => {
          this.snackBar.open(error.error?.message || 'Failed to delete bid rate', 'Fail', { duration: 5000 });
          this.matdialogref.close();
        }
      );
    } else if (this.data.data === 'reject-bid') {
      this.matdialogref.close({ event: 'Success' });
    } else {
      this.services.deleteBid(this.data.item._id, this.token).subscribe(
        () => {
          this.matdialogref.close({ event: 'Success' });
        },
        (error) => {
          this.snackBar.open(error.error?.message || 'Failed to delete bid', 'Fail', { duration: 5000 });
          this.matdialogref.close();
        }
      );
    }
  }

  close() {
    this.matdialogref.close();
  }
}
